module.exports = __webpack_public_path__ + "img/full5-min.d0fdf78f.png";